import { Component } from '@angular/core';
import { SystemModuleService } from '../crud-service';
import { SystemModuleCrudIndex } from './crud-index';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';
import { FormGroup } from '@angular/forms';
import { take } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-system-module-index',
  templateUrl: './crud-index.component.html',
  styleUrls: ['./crud-index.component.sass'],
  providers: [SystemModuleService],
})
export class SystemModuleIndexComponent extends SystemModuleCrudIndex {

  ngOnInit(): void {}

  override filterFields: IFieldConfig[] = [
    {
      type: TypeComponentFieldEnum.INPUT,
      label: 'Sistema',
      name: 'system',
      value: '',
    },
    {
      type: TypeComponentFieldEnum.INPUT,
      label: 'Nome',
      name: 'name',
      value: '',
    },
  ];

  override submitAdvancedFilter(filterForm: FormGroup) {
    let _filterForm = this.getFilters(filterForm.value);
    this.service
      .findByFilter(_filterForm, this.params)
      .pipe(take(1))
      .subscribe((dataWithPagination: any) => {
        let data = dataWithPagination[0];
        this.length = dataWithPagination[1];

        this.dataSource = new MatTableDataSource<any>(
          data.map((item: any) => {
            return item;
          })
        );
      });
  }

  private getFilters(filter: any) {
    let params: any = {};

    if (filter.system) params.system = filter.system.toUpperCase();
    else delete params.system;

    if (filter.name) params.name = filter.name.toUpperCase();
    else delete params.name;

    return params;
  }
}
